import React from "react";
import styled from "styled-components";
import { withPrefix } from "gatsby";

const BaitToPlateEntityTypeIcon = ({ type }) => {

  
  return (
    <StyledBaitToPlateEntityTypeIcon className={`icon-${type}`}>
      {type === "vessel" && <IconVessel />}
      {type === "processor" && <IconProcessor />}
      {type === "importer" && <IconImporter />}
      {type === "buyer" && <IconBuyer />}
    </StyledBaitToPlateEntityTypeIcon>
  );
};

export default BaitToPlateEntityTypeIcon;

const StyledBaitToPlateEntityTypeIcon = styled.div`
  position: relative;
  display: block;
  width: 100%;
  &::before {
    content: "";
    position: relative;
    display: block;
    padding-bottom: 70%;
  }
  svg {
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
    > * {
      fill: currentColor;
    }
  }
`;


const IconVessel = () => (
  <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 274.28 108.18">
  <g id="Layer_1-2" data-name="Layer 1">
    <path d="m274.28,71.44v-2.1s-16.43,3.74-40.67,7.13v-23.87h4.37l1.14-8.41h-5.51v-3.44c0-1.21-.98-2.19-2.19-2.19s-2.19.98-2.19,2.19v3.44h-5.51l1.14,8.41h4.37v24.47c-5.75.76-11.87,1.49-18.28,2.14l-1.73-5.56h-10.34l-1.23-4.67h-9.21v-1.78c0-1.26-1.02-2.27-2.27-2.27s-2.27,1.02-2.27,2.27v1.78h-2.91v12.43c-5.22.23-10.51.37-15.83.4v-18.34c1.81-.21,3.63-.41,5.41-.62v-7.77c-4.31.52-8.74,1.01-13.22,1.46v-6.05c0-1.72-1.39-3.11-3.11-3.11s-3.11,1.39-3.11,3.11v6.66c-3.11.29-6.25.56-9.43.82v-3.38c0-1.31-1.06-2.37-2.37-2.37s-2.37,1.06-2.37,2.37v3.76c-6.41.48-12.97.89-19.62,1.23v-22.22l9.7-.9v-2.03h-9.7v-10.7l9.7-.9v-2.03h-19.99l-2.19-20.8-2.19,20.8v39.41c-.46.02-.91.04-1.37.05-6.13.2-12.18.33-18.15.4v7.77c1.79-.02,3.61-.06,5.41-.09v6.79h-14.07v-3.68h1.93v-6.13h-10.47v6.13h1.93v3.68h-9.52l-4.38-8.17h-1.14v-3.18c0-.36-.14-.71-.4-.96l-4.2-4.2v3.56l1.99,1.99c.18.18.28.43.28.69v2.11h-3.91v-3.18c0-.36-.14-.71-.4-.96l-4.2-4.2v3.56l1.99,1.99c.18.18.28.43.28.69v2.11h-4.2v-3.18c0-.36-.14-.71-.4-.96l-4.2-4.2v3.56l1.99,1.99c.18.18.28.43.28.69v2.11h-2.08v8.17h-6.33v-34.38c0-1.21-.98-2.19-2.19-2.19s-2.19.98-2.19,2.19v1.69H5.08l19.88,8.7v23.99h-1.69v6.69H0v3.9c0,12.41,10.06,22.47,22.47,22.47h230.26c10.16,0,9.46-5.74,2.99-8.47-3.93-1.66-2.51-5.29-.08-8.45l18.64-19.83ZM112.97,34.43h-5.9v-9.74l5.9-.55v10.29Zm-5.9,3.89l5.9-.55v22.02c-1.96.09-3.93.17-5.9.25v-21.73Z" stroke-width="0"/>
  </g>
</svg>
);

const IconProcessor = () => (
  <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 92.5 99.01">
  <g id="Layer_1-2" data-name="Layer 1">
    <path d="m92.41,41.13l-21.34-15.72v15.28l-20.74-15.28v15.43l-20.95-15.43v15.72h-12.23L10.65,0h-4.16L0,41.13v57.88h8.85v-9.32h19.04v9.32h8.85v-9.32h19.04v9.32h8.85v-9.32h19.04v9.32h8.85v-57.88h-.1Zm-27.79,35.11v-10.12h8.3v10.12h-8.3Zm-27.89-10.12h8.3v10.12h-8.3v-10.12Zm-8.85,10.12h-8.29v-10.12h8.29v10.12Zm27.89-27.67v10.12h-8.29v-10.12h8.29Zm-10.74,0v10.12h-8.3v-10.12h8.3Zm2.45,17.55h8.29v10.12h-8.29v-10.12Zm17.14-7.44v-10.12h8.3v10.12h-8.3Zm-36.73,0h-8.29v-10.12h8.29v10.12Zm-19.04-10.12h8.3v10.12h-8.3v-10.12Zm0,17.55h8.3v10.12h-8.3v-10.12Zm0,21.13v-3.58h19.04v3.58H8.85Zm27.89,0v-3.58h19.04v3.58h-19.04Zm46.92,0h-19.04v-3.58h19.04v3.58Zm0-11.01h-8.29v-10.12h8.29v10.12Zm0-17.55h-8.29v-10.12h8.29v10.12Z" stroke-width="0"/>
  </g>
</svg>
);

const IconImporter = () => (
  <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 154.31 109.11">
  <g id="Layer_1-2" data-name="Layer 1">
    <g>
      <path d="m107.76,90.75v-1.69h.85v-40.24h-3.67v12.28h-3.3V10.42h-15.2v10.02h3.81v57.55c-.49-.14-.98-.27-1.49-.36l-1.19-7.63-4.63-.72-9.86-32.96,2.76-1.02c.27-.1.41-.4.31-.67l-2.55-6.94c-.08-.21-.28-.34-.49-.34-.06,0-.12.01-.18.03l-2.27.83-3.49-11.66c-1.89-6.32-7.7-10.64-14.29-10.64h-20.69c-7.6,0-13.77,6.16-13.77,13.77v39.61l-9.32-1.44c-5.03,0-9.1,4.08-9.1,9.1v28.19c0,2.08,1.69,3.76,3.76,3.76h3.83c.93,5.78,5.92,10.19,11.96,10.19s11.03-4.42,11.96-10.19h39.43c2.29,5.96,8.05,10.19,14.82,10.19,8.51,0,15.44-6.7,15.84-15.11h.04v-7.2h3.3v2.26h.67v3.32h0c.02.89.82,1.6,1.79,1.56l46.92-1.56v-1.62h-46.55Zm-15.67-70.31h2.81v59.8c-.88-.62-1.82-1.16-2.81-1.59V20.45Zm-59.89-8.52h20.69c3.91,0,7.42,2.62,8.54,6.36l9.18,30.68-1.92,1.8-8.66-8.66,3.34-3.34c.48-.48.48-1.25,0-1.72-.24-.24-.55-.36-.86-.36s-.62.12-.86.36l-8.96,8.96c-.48.48-.48,1.25,0,1.72.24.24.55.36.86.36s.62-.12.86-.36l4.19-4.19,8.62,8.62-1.11,1.05v5.36h-2.07v2.54h2.07v5.57l-7.61-1.18-.48-1.93h-6.37v-4.07h2.58c.84,0,1.52-.68,1.52-1.52v-1.1c0-.84-.68-1.52-1.52-1.52h-16.55v-4.56l-5.55-10.4h-4.99v7.83h-.89l-1.83,9.71V19.69c0-4.28,3.48-7.77,7.77-7.77Zm-12.64,89.56c-2.49,0-4.5-2.02-4.5-4.5s2.01-4.5,4.5-4.5,4.5,2.01,4.5,4.5-2.01,4.5-4.5,4.5Zm66.2-1.51c-3.73,0-6.75-3.02-6.75-6.75s3.02-6.75,6.75-6.75,6.75,3.02,6.75,6.75-3.02,6.75-6.75,6.75Zm15.88-29.69v-3.25h3.3v3.25h-3.3Z" stroke-width="0"/>
      <rect x="111.44" y="59.86" width="37.08" height="27.94" stroke-width="0"/>
      <rect x="111.44" y="29.93" width="37.08" height="27.94" stroke-width="0"/>
      <rect x="111.44" width="37.08" height="27.94" stroke-width="0"/>
    </g>
  </g>
</svg>
)

const IconBuyer = () => (
  <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 92.97 85.91">
  <g id="Layer_1-2" data-name="Layer 1">
    <g>
      <rect y="33.8" width="92.97" height="4.92" stroke-width="0"/>
      <path d="m89.47,26.45h-26.54v-4.53h6.59V0H23.45v21.92h6.16v4.53H3.5v4.92h85.97v-4.92ZM28.45,5h36.07v11.92H28.45V5Zm5.55,16.92h24.55v4.53h-24.55v-4.53Z" stroke-width="0"/>
      <path d="m0,85.91h60.74v-29.65c0-.55.44-.99.99-.99h7.82c.55,0,.99.44.99.99v29.65h1.94v-29.65c0-.55.44-.99.99-.99h7.82c.55,0,.99.44.99.99v29.65h10.71v-44.75H0v44.75Zm60.74-37.62c0-.55.44-.99.99-.99h19.55c.55,0,.99.44.99.99v3.17c0,.55-.44.99-.99.99h-19.55c-.55,0-.99-.44-.99-.99v-3.17Zm-28.12,0c0-.55.44-.99.99-.99h19.55c.55,0,.99.44.99.99v8.33c0,.55-.44.99-.99.99h-19.55c-.55,0-.99-.44-.99-.99v-8.33Zm0,13.28c0-.55.44-.99.99-.99h19.55c.55,0,.99.44.99.99v8.33c0,.55-.44.99-.99.99h-19.55c-.55,0-.99-.44-.99-.99v-8.33Zm-24.58-13.28c0-.55.44-.99.99-.99h19.55c.55,0,.99.44.99.99v8.33c0,.55-.44.99-.99.99H9.03c-.55,0-.99-.44-.99-.99v-8.33Zm0,13.28c0-.55.44-.99.99-.99h19.55c.55,0,.99.44.99.99v8.33c0,.55-.44.99-.99.99H9.03c-.55,0-.99-.44-.99-.99v-8.33Z" stroke-width="0"/>
      <rect x="66.65" y="70.66" width="1.93" height="5.13" stroke-width="0"/>
      <rect x="74.4" y="70.66" width="1.93" height="5.13" stroke-width="0"/>
    </g>
  </g>
</svg>
);


